export default __webpack_public_path__ + "static/media/categoria_prod.6f891a73.svg";